import { Route } from "@angular/router";
import { authGuard, devGuard } from "@core/guards";
import { TrustProfilePageComponent } from "./components/trust-profile-page/trust-profile-page.component";
import { TrustsPageComponent } from "./components/trusts-page/trusts-page.component";

export function getTrustsRoutes(): Route[] {
  return [
    {
      path: 'trusts',
      canActivate: [authGuard, devGuard],
      canActivateChild: [authGuard, devGuard],
      children: [
        {
          title: 'Trusts',
          path: '',
          component: TrustsPageComponent,
        },
        {
          title: "Trust Profile",
          path: ':id',
          component: TrustProfilePageComponent,
        },
      ]
    }
  ];
}
